/**
 * Centralized configuration for TanStack Query
 */

import { HttpError, isNetworkError } from "@/shared/api/errors"

export const QUERY_CONFIG = {
	/**
	 * Default stale time for queries in milliseconds
	 * Data is considered fresh for 1 minute
	 */
	DEFAULT_STALE_TIME: 60_000,

	/**
	 * Default cache time for queries in milliseconds
	 * Unused data is garbage collected after 5 minutes
	 */
	DEFAULT_CACHE_TIME: 5 * 60_000,

	/**
	 * Number of retry attempts for failed queries
	 */
	DEFAULT_RETRY: 3,

	/** Повторы запроса, на который сервер ответил 5xx. */
	SERVER_ERROR_RETRY: 2,

	/** Retries for a command whose response never arrived (drop, timeout). */
	MUTATION_NETWORK_RETRY: 2,
} as const

/**
 * Typed `meta` of every query. The `QueryCache` in `src/router.tsx` calls
 * `onError` once per failed fetch (after retries), not once per observer, so
 * an owner declares its error side effect here instead of in an effect.
 */
type AppQueryMeta = {
	onError?: (error: Error) => void
}

declare module "@tanstack/react-query" {
	interface Register {
		queryMeta: AppQueryMeta
	}
}

export function retryTransient(failureCount: number, error: unknown): boolean {
	if (isNetworkError(error)) return failureCount < QUERY_CONFIG.DEFAULT_RETRY
	if (error instanceof HttpError) {
		return error.status >= 500 && failureCount < QUERY_CONFIG.SERVER_ERROR_RETRY
	}
	return false
}

export function retryNetwork(failureCount: number, error: Error): boolean {
	return (
		isNetworkError(error) && failureCount < QUERY_CONFIG.MUTATION_NETWORK_RETRY
	)
}
